import { Component, OnInit, AfterViewInit, OnDestroy, HostBinding, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { delay, filter } from 'rxjs/operators';

import { ResponsiveBreakpointsService } from '../../responsive-breakpoints.service';
import { SideMenusService } from '../../side-menus/side-menus.service';

@Component({
  selector: 'app-teams-layout',
  templateUrl: './teams-layout.component.html',
  styleUrls: ['./teams-layout.component.scss']
})
export class TeamsLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('class.layout-teams') layoutFlag = true;

  @ViewChild('mainSidenav') mainSidenav!: MatSidenav;
  @ViewChild('altSidenav') altSidenav!: MatSidenav;

  @HostBinding('class.main-sidenav-opened') mainSidenavOpened = false;
  @HostBinding('class.alt-sidenav-opened') altSidenavOpened = false;
  mainSideMenuMode: string = 'side';

  menuOpen = false;

  private mainSidenavSubscription?: Subscription;
  private altSidenavSubscription?: Subscription;
  private screenSizeChangeSubscription?: Subscription;
  private changeMainMenuModeSubscription?: Subscription;
  private menuStateSubscription?: Subscription;
  private routerSubscription?: Subscription;

  isMultichatRoute = false;
  showBusinessMenu = false;

  constructor(
    private sideMenusService: SideMenusService,
    private responsiveBreakpointsService: ResponsiveBreakpointsService,
    private router: Router
  ) {
    const size = this.responsiveBreakpointsService.currentScreenSize;
    this.mainSideMenuMode = 'side'; // Always use 'side' mode for beta menu
    this.mainSidenavOpened = true; // Always open for beta menu hover functionality
  }

  ngOnInit(): void {
    this.screenSizeChangeSubscription = this.responsiveBreakpointsService.screenSizeChangeSubject
      .pipe(delay(0))
      .subscribe((event) => {
        if (event === 'small') {
          this.sideMenusService.changeMainMenuModeSubject.next('push');
        } else {
          this.sideMenusService.changeMainMenuModeSubject.next('side');
        }
      });

    // Check if we're on executive-chat route
    this.checkMultichatRoute();
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkMultichatRoute();
      });
  }

  private checkMultichatRoute(): void {
    const currentUrl = this.router.url;
    this.isMultichatRoute =
      currentUrl.includes('/multi-ai/executive-chat') ||
      currentUrl.includes('/multi-ai/exective-chat') ||
      currentUrl.includes('/executive-chat') ||
      currentUrl.includes('/exective-chat');

    const coachMenuAllowedRoutes = ['/ai/clarity', '/ai/clarichat', '/ai/compare-mode', '/search-history'];
    this.showBusinessMenu = coachMenuAllowedRoutes.some((route) => currentUrl.includes(route));
  }

  ngAfterViewInit(): void {
    this.mainSidenavSubscription = this.sideMenusService.toggleMainMenuSubject.subscribe((event) => {
      if (event === 'open') this.mainSidenav.open();
      else if (event === 'close') this.mainSidenav.close();
      else this.mainSidenav.toggle();
    });

    this.altSidenavSubscription = this.sideMenusService.toggleAltMenuSubject.subscribe((event) => {
      if (event === 'open') this.altSidenav.open();
      else if (event === 'close') this.altSidenav.close();
      else this.altSidenav.toggle();
    });

    this.changeMainMenuModeSubscription = this.sideMenusService.changeMainMenuModeSubject.subscribe((mode) => {
      this.mainSideMenuMode = mode;
    });

    this.menuStateSubscription = this.sideMenusService.mainMenuOpen$.subscribe((open) => {
      this.menuOpen = open;
    });
  }

  ngOnDestroy(): void {
    this.mainSidenavSubscription?.unsubscribe();
    this.altSidenavSubscription?.unsubscribe();
    this.screenSizeChangeSubscription?.unsubscribe();
    this.changeMainMenuModeSubscription?.unsubscribe();
    this.menuStateSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
  }

  toggleMainMenu(): void {
    this.sideMenusService.toggleMainMenuSubject.next('toggle');
  }

  openedStart(): void {
    this.mainSidenavOpened = false;
  }

  mainSidenavToggled(opened: boolean): void {
    // Force sidenav to stay open for beta menu hover functionality
    if (!opened && this.mainSidenav) {
      setTimeout(() => {
        if (this.mainSidenav && !this.mainSidenav.opened) {
          this.mainSidenav.open();
        }
      }, 0);
    }
    this.mainSidenavOpened = true; // Always set to true
    this.sideMenusService.setMainMenuState(true);
  }

  altSidenavToggled(opened: boolean): void {
    this.altSidenavOpened = opened;
  }
}
